export default {
      id: "common__van-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__van",
      toString: function () {
        return this.url;
      }
    }